const getPromedioSinMateriales = ({ ingresos, sumaLibras }) => sumaLibras === 0 ? 0 : (ingresos / sumaLibras);
export default getPromedioSinMateriales